import { Badge } from '@cocoonspace/ui/components/badge'
import { useLingui } from '@lingui/react/macro'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

type ProviderKey = 'password' | 'google' | 'apple' | 'microsoft'

type State = {
	lastUsed: ProviderKey | null
	updatedAt: number | null
	markUsed: (p: ProviderKey) => void
	clearIfExpired: () => void
}

const TTL_MS = 30 * 24 * 60 * 60 * 1000 // 30 days

export const useLastUsed = create<State>()(
	persist(
		(set, get) => ({
			lastUsed: null,
			updatedAt: null,
			markUsed: (p) => set({ lastUsed: p, updatedAt: Date.now() }),
			clearIfExpired: () => {
				const { updatedAt } = get()
				if (updatedAt && Date.now() - updatedAt > TTL_MS) {
					set({ lastUsed: null, updatedAt: null })
				}
			},
		}),
		{
			name: 'auth.lastUsedProvider',
			storage: createJSONStorage(() => localStorage),
			// optional versioning/migration if TTL logic changes later
			onRehydrateStorage: () => (state) => {
				// runs after state is loaded
				state?.clearIfExpired()
			},
			// if you want multi-tab sync:
			// skipHydration: false (default) – Zustand persist already listens to 'storage' events
		},
	),
)

export const LastUsedBadge = () => {
	const { t } = useLingui()

	return (
		<Badge
			size='sm'
			variant='outline'
			className='-top-3 -right-3 absolute bg-card text-foreground shadow-sm'
		>
			{t`Dernière méthode utilisée`}
		</Badge>
	)
}
